module.exports = __webpack_public_path__ + "img/gs.50cf5f9a.svg";